import React from "react";

const WHATSAPP_URL = "https://wa.me/971561705528?text=Hello%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services.";

function FloatingWhatsApp() {
  return (
    <a
      className="floating-whatsapp"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp at +971 56 170 5528"
      title="Chat with us on WhatsApp"
    >
      <span className="floating-whatsapp__pulse" aria-hidden="true" />
      <span className="floating-whatsapp__icon" aria-hidden="true">
        <i className="fab fa-whatsapp" />
      </span>
      <span className="floating-whatsapp__content">
        <small>Chat with us</small>
        <strong>+971 56 170 5528</strong>
      </span>
    </a>
  );
}

export default FloatingWhatsApp;
